<template>
  <div :class="$style.navigation">
    <div :class="$style.toggleItem">
      <div
        :class="$style.arrow"
        @click="toggleSidebar"
      >
        <img src="@/assets/images/icons/navigation/big-arrow.svg">
      </div>
      <h1 :class="$style.display">
        {{ $t('collapse') }}
      </h1>
    </div>
    <navigation
      v-for="item in menu"
      :key="item.slug"
      :slug="item.slug"
      :name="item.name"
      :opened="opened[item.slug]"
      :categories="item.categories"
      @toggle="toggle(item.slug)"
    />
    <div :class="$style.navigationItem">
      <div
        :class="$style.sidebarItem"
        :title="$t('global.logout')"
        @click="logout"
      >
        <img src="@/assets/images/icons/logout.svg">
        <div>{{ $t('global.logout') }}</div>
      </div>
      <switch-locale :class="$style.sidebarLocal" />
    </div>
  </div>
</template>

<script>
  import { menu } from '@/assets/scripts/menu';
  import SwitchLocale from '@/components/common/locale/locale.vue';
  import Navigation from './navigation.vue';

  export default {
    components: {
      Navigation,
      SwitchLocale,
    },
    props: {
      isViewSidebar: {
        type: Boolean,
        required: true,
      },
    },
    data: () => ({
      opened: menu.reduce((acc, item) => {
        acc[item.slug] = true;
        return acc;
      }, {}),
    }),
    computed: {
      menu: () => menu,
    },
    methods: {
      toggle(slug) {
        this.opened[slug] = !this.opened[slug];
      },
      logout() {
        this.$emit('logout');
      },
      toggleSidebar() {
        this.$emit('toggle');
      },
    },
  };
</script>

<style lang="scss" module>
  .navigation {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 20px 0 0 20px;
    width: 250px;
  }
  .toggleItem {
    display: flex;
    align-items: center;
    background: $white;
    padding: 20px;
  }
  .navigationItem {
    background: $white;
    padding: 20px;
    display: flex;
    justify-content: space-between;
  }

  .sidebarItem {
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 5px;

    img {
      display: block;
      height: 18px;
      width: 18px;
    }
  }

  .sidebarLocal {
    display: flex;
    gap: 5px;
  }

  .arrow {
    cursor: pointer;
    display: inline-flex;
    transform: rotate(90deg);
  }

  .display {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: $black;
    display: inline-flex;
    margin: 0 0 0 10px;
  }
</style>
